import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IFileRequestSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';

export const useClientCreateFileRequestSurveyResponseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: IFileRequestSurveyResponse) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({ body, token }: { body: IFileRequestSurveyResponse; token: string }) => {
			return apiClient.post<IFileRequestSurveyResponse>(`survey/fileRequest/response/?token=${token}`, body);
		},
		onError,
		onSuccess,
	});
};
